var scroll_left = "T' port";
var scroll_right = "T' starboard";
var scroll_up = "T' heavens";
var scroll_down = "T' sea";
var enPT = {
	scroll_left: scroll_left,
	scroll_right: scroll_right,
	scroll_up: scroll_up,
	scroll_down: scroll_down
};

export { enPT as default, scroll_down, scroll_left, scroll_right, scroll_up };
